var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cc-facebook__tab"},[_c(_setup.AdAccount),_c(_setup.CampaignName),_c(_setup.SpecialAdCategories),_c(_setup.CampaignDetails),_c(_setup.AdvantageCampaignBudget)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }